import React from "react"
import TeacherFormContainer from "../Container/TeacherFormContainer"
import PoliceChkForm from "./PoliceChkForm"
import { connect } from "react-redux"
import { updatePersonalDetails } from "../../redux/homePage/homePage.actions"
import { notify } from "react-notify-toast"
import { parseDate } from "../../Helper"

class PoliceCheck2 extends React.Component {
  state = {
    police_check_filename: this.props.user.police_check_filename,
    police_check_url: this.props.user.police_check_url,
    police_check_release: parseDate(this.props.user.police_check_release),
    police_check_result: this.props.user.police_check_result,
    police_check_type: this.props.user.police_check_type,
    police_check_status: this.props.user.police_check_verification_status,
    police_check_issuing_organisation: this.props.user
      .police_check_issuing_organisation,
  }

  handleStateChange = (key, value) => {
    this.setState({ [key]: value })
  }

  handleFormFieldChange = (e) => {
    this.setState({ [e.target.id]: e.target.value })
  }

  handleDateChange = (date) => {
    this.setState({ police_check_release: date })
  }

  handleRadioChange = (e) => {
    this.setState({ police_check_type: e.target.title })
  }

  handleSubmit = (e) => {
    e.preventDefault()
    const fields = [
      "rbEmployment",
      "rbVolunteer",
      "police_check_result",
      "police_check_issuing_organisation",
      "police_check_release",
    ]
    let errors = false

    for (let field of fields) {
      const input = document.getElementById(field)
      if (!input.reportValidity()) {
        errors = true
        break;
      }
    }

    if (errors) {
      notify.hide();
      notify.show("You are missing one or more field(s)!")
      errors = true
    }

    if (!errors) {
      notify.hide();
      this.props.updatePersonalDetails({ ...this.state })
    }
  }

  getTabs = () => {
    const tabs = [
      {
        pathname: "/personalid",
        text: "Personal ID",
      },
      {
        pathname: "/visa",
        text: "Visa Details",
      },
      {
        pathname: "/policecheck",
        text: "Police Check (Opt.)",
        active: true,
      },
      {
        pathname: "/wwcc",
        text: "WWCC (Optional)",
      },
      {
        pathname: "/usiCheck",
        text: "USI Check (Opt.)",
      },
    ]

    if (this.props.user?.is_elt) {
      tabs.push({
        pathname: "/uploadPayLevel",
        text: "Pay Level Evidence",
      })
    }

    if (this.props.user?.is_childhood_teacher) {
      tabs.push({
        pathname: "/ececcheck",
        text: "First AID",
      })
    }

    return tabs
  }

  tabs = this.getTabs()

  render() {
    return (
      <div>
        <TeacherFormContainer
          header="Identification"
          tabs={this.tabs}
          handleSubmit={this.handleSubmit}
        >
          <PoliceChkForm
            handleStateChange={this.handleStateChange}
            handleFormFieldChange={this.handleFormFieldChange}
            handleDateChange={this.handleDateChange}
            handleRadioChange={this.handleRadioChange}
            state={this.state}
          />
        </TeacherFormContainer>
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    user: state.user.user,
  }
}

const mapDispatchToProps = (dispatch) => ({
  updatePersonalDetails: (user) => dispatch(updatePersonalDetails(user)),
})

export default connect(mapStateToProps, mapDispatchToProps)(PoliceCheck2)
